import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Helmet from 'react-helmet'
import { TabList, Tab, Tabs, TabPanel } from 'react-tabs'
import Modal from 'react-awesome-modal'
import { Button, Alert } from 'loyal-react'

import Splash from 'App/Splash'

import client from './LikePlusClient'
import clientCustom from './LikePlusClientCustom'

import Banner from './Banner'
import Home from './Tabs/Home/Home'
import Recharge from './Tabs/Recharge/Recharge'
import RechargeAside from './Tabs/Recharge/RechargeAside'
import Help from './Tabs/Help/Help'
import HelpCustom from './Tabs/Help/HelpCustom'
import HelpAside from './Tabs/Help/HelpAside'
import RequestCard from './Tabs/RequestCard/RequestCard'
import RequestAside from './Tabs/RequestCard/RequestAside'

import yn from 'yn'

class LikePlus extends Component {
  _isMounted = false;

  constructor (props) {
    super(props)
    this.state = {
      modalVisible: false,
      modalCopyCard: false,
      modalDownloadApp: false,
      modalLoadingVisible: true,
      hasCard: false,
      page: 'home',
      initialCredit: 0,
      initialMiles: 0,
      totalPoints: 0,
      rechargePoints: 0,
      rechargeCredits: 0,
      success: false,
      address: {},
      alert: {
        show: false,
        isError: false,
        title: '',
        message: ''
      },
      transactionId: '',
      intervalObservable: null,
      disabledConfirmButton: true,
      loadingConfirmButton: false
    }
  }

  handlePage = (page) => {
    this.setState({ page })
  }

  handleInitialCredit = (initialCredit) => {
    this.setState({ initialCredit })
  }

  handleInitialMiles = (initialMiles) => {
    this.setState({ initialMiles })
  }

  handleSuccess = (success) => {
    this.setState({ success })
  }

  handleTotalPoints = (totalPoints) => {
    this.setState({ totalPoints })
  }

  handleRechargePoints = (rechargePoints) => {
    this.setState({ rechargePoints })
  }

  handleRechargeCredits = (rechargeCredits) => {
    this.setState({ rechargeCredits })
  }

  handleAddress = (address) => {
    this.setState({ address })
  }

  handleAlert = (alert) => {
    this.setState({ alert })
  }

  handleAlertClose = () => {
    this.setState({ alert: { show: false } })
  }

  handleTransactionId = (transactionId) => {
    this.setState({ transactionId })
  }

  handleIntervalObservable = (intervalObservable) => {
    this.setState({ intervalObservable })
  }

  handleDisabledConfirmButton = (disabledConfirmButton) => {
    this.handleAlertClose()
    this.setState({ disabledConfirmButton })
  }

  handleLoadingConfirmButton = (loadingConfirmButton) => {
    this.setState({ loadingConfirmButton })
  }

  handleOnTabSelect = (tab) => {
    if (tab === 'first-access' || tab === 'manage-card') {
      this.setState({ modalDownloadApp: true })
    } else if (tab === 'duplicate') {
      this.setState({ modalCopyCard: true })
    } else {
      if (tab === 'home') {
        this.handleSuccess(false)
      }
      this.setState({ page: tab })
    }
  }

  componentDidMount () {
    let cpf = this.props.participant.cpf.value
    if (cpf) {
      if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM)) {
        this.searchCardCustom(cpf)
      } else {
        this.searchCard(cpf)
      }
    }
  }

  componentDidUpdate (prev) {
    let cpf = this.props.participant.cpf.value
    if (cpf && (prev.participant.cpf.value !== cpf)) {
      if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM)) {
        this.searchCardCustom(cpf)
      } else {
        this.searchCard(cpf)
      }
    }
  }
  handleClickTab (selector) {
    const previousTab = document.querySelector(selector)
    if (previousTab) {
      previousTab.click()
    }
  }
  errorHasCard () {
    this.setState({ hasCard: false })
    let alert = { show: true, isError: true, title: 'Erro ao buscar o cartão', description: 'Foi encontrado um erro ao buscar o cartão do like+' }
    this.handleAlert(alert)
  }
  searchCard (cpf) {
    let token = this.props.accessToken
    client.searchCards(cpf, token)
      .then((hasCard) => {
        if (hasCard.success === true) {
          if (hasCard.hasCard) {
            this.selectRechargeTab()
            this.setState({ hasCard: true })
          } else {
            this.setState({ hasCard: false })
          }
        } else {
          this.errorHasCard()
        }
        this.setState({ modalLoadingVisible: false })
      }).catch((hasCard) => {
        this.errorHasCard()

        this.setState({ modalLoadingVisible: false })
      })
  }

  searchCardCustom (cpf) {
    clientCustom.searchCards(cpf)
      .then((hasCard) => {
        if (hasCard.success === true) {
          if (hasCard.hasCard) {
            this.selectRechargeTab()
            this.setState({ hasCard: true })
          } else {
            this.setState({ hasCard: false })
          }
        } else {
          this.errorHasCard()
        }
        this.setState({ modalLoadingVisible: false })
      }).catch((hasCard) => {
        this.errorHasCard()

        this.setState({ modalLoadingVisible: false })
      })
  }

  selectRechargeTab () {
    setTimeout(() => {
      const rechargeTab = document.querySelector(`.recharge-tab-like-plus`)
      if (rechargeTab) {
        rechargeTab.click()
      }
    }, 100)
  }

  formatAddress (address) {
    let addressFormated = {
      addressType: 'Residencial',
      zipCode: address.zipCode.value,
      zipCodeDisabled: address.zipCode.disabled,
      street: address.addressText.value,
      streetDisabled: address.addressText.disabled,
      number: address.number.value,
      numberDisabled: address.number.disabled,
      complement: address.complement.value,
      complementDisabled: address.complement.disabled,
      city: address.city.value,
      cityDisabled: address.city.disabled,
      state: address.state.value,
      stateDisabled: address.state.disabled
    }

    return addressFormated
  }

  async getCardTaxes (token) {
    let retorno = await client.searchTaxes(token)
    return retorno
  }

  async getPointsConverted (points, token) {
    let retorno = null
    if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM)) {
      retorno = await clientCustom.pointsToCash(points, token)
    } else {
      retorno = await client.pointsToCash(points, token)
    }
    return retorno
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Like Plus - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='modalConfirmationVoucher'>

          <Modal width='580' height='400' effect='fadeInUp' visible={this.state.modalDownloadApp}>
            <div data-campaign={(this.props.profile && this.props.profile['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
              <div className='bg-white radius row'>
                <div className='col-12 border-color-ui-3 bg-white border px-3 py-3'>
                  <h2>{this.state.page === 'first-access' ? 'Primeiro Acesso' : 'Gerenciar Meu Cartão'}</h2>
                </div>

                <div className='col-12'>
                  <div className='row px-3 py-3'>
                    <div className='col-12 bg-white pb-2'>
                      <p>Baixe nosso aplicativo para {this.state.page === 'first-access' ? 'seu primeiro acesso' : 'gerenciar seu cartão'}.</p>
                    </div>
                    <div className='col-auto'>
                      <a href='https://apps.apple.com/br/app/cart%C3%A3o-like/id1535997203' target='_blank'>
                        <img src='https://s3.amazonaws.com/ltm.ragnarok.tenants.prod.1.email-content/appstore.png' />
                      </a>
                    </div>
                    <div className='col-auto'>
                      <a href='https://play.google.com/store/apps/details?id=br.com.acgsa.cartao_like_mais' target='_blank'>
                        <img src='https://s3.amazonaws.com/ltm.ragnarok.tenants.prod.1.email-content/googleplay.png' />
                      </a>
                    </div>
                    <div className='col-12 bg-white pt-2'>
                      <p>Ou acesse <a href='https://siteportador.acgsa.com.br/emissores/index.aspx?IDE=40&FNL=3&TEMA=31&IDP=82,104,146,158,171,192,199,203,215,216,220,221' className='txt-underline' target='_blank'>nosso site</a>.</p>
                    </div>
                  </div>
                  <div className='row px-4 pb-3 border-bottom-brand-1'>
                    <Button className='mb-2 mb-md-0 col-auto px-3 mx-auto' onClick={() => this.setState({ modalDownloadApp: false })} text='Fechar' />
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal width='580' height='400' effect='fadeInUp' visible={this.state.modalCopyCard}>
            <div data-campaign={(this.profile && this.profile['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
              <div className='bg-white radius'>
                <div className='col-12 border-color-ui-3 bg-white border px-3 py-4'>
                  <h2>Solicitação de 2ª Via.</h2>
                </div>
                <div className='d-flex px-3 py-3 flex-column align-items-center justify-content-center'>
                  <div className='col-12 d-flex justify-content-center'>
                    <div className='icon icon_contact' />
                  </div>
                  <p className='mt-2 txt-center'>
                    Fale com a nossa central de atendimento* <strong>(11) 4020-0221</strong> de segunda a sexta – 9h às 18h, ou entre em contato pelo e-mail <a href='mailto:atendimento@acgsa.com.br'><strong>atendimento@acgsa.com.br</strong></a>.
                  </p>
                </div>
                <div className='d-flex px-3 pb-3 border-bottom-brand-1'>
                  <Button className='mb-2 mb-md-0 col-auto px-3 mx-auto' onClick={() => this.setState({ modalCopyCard: false })} text='Fechar' />
                </div>
              </div>
            </div>
          </Modal>
          <Modal width='580' height='400' effect='fadeInUp' visible={this.state.modalVisible}>
            <div className='bg-white radius' data-campaign={(this.profile && this.profile['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
              <div className='col-12 border-color-ui-3 bg-white border px-3 py-4'>
                <h2>Você será redirecionado</h2>
              </div>
              <div className='d-flex px-3 py-3 flex-column align-items-center justify-content-center'>
                <div className='col-12 d-flex justify-content-center'>
                  <div className='icon icon_redirect_likeplus' />
                </div>
                <p className='mt-2 txt-center'>
                  O serviço que você escolheu só está disponível no site do parceiro.
                  Clique em <strong>Vamos lá</strong> para ser redirecionado ou <strong>Cancelar</strong> para voltar a página do Cartão Pré-Pago Like+.
                </p>
              </div>
              <div className='d-flex px-3 pb-3 border-bottom-brand-1'>
                <Button className='mr-md-1 mb-2 mb-md-0 col-6' onClick={() => this.setState({ modalVisible: false })} text='Cancelar' />
                <a className='mb-2 ml-1 m-md-0 btn btn-featured btn-icon txt-button txt-font-body col-6 p-0 d-flex align-items-center justify-content-center' role='button'>Vamos lá</a>
              </div>
            </div>
          </Modal>
          <Modal width='580' height='400' effect='fadeInUp' visible={this.state.modalLoadingVisible}>
            <div className='bg-white radius' data-campaign={(this.profile && this.profile['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
              <Splash text='Checando seu cartão' />
            </div>
          </Modal>
        </div>
        {
          this.state.page === 'home' && this.state.hasCard === false && <Banner hasCard={this.state.hasCard} />
        }
        {this.state.alert.show &&
          (<div className='mx-md-5 mx-1 mt-5 div-alert' >
            <Alert
              isError={this.state.alert.isError}
              title={this.state.alert.title}
              description={this.state.alert.message}
              onClose={this.handleAlertClose}
            />
          </div>)}

        <div className='container pt-sm-2 pt-md-3 pb-sm-2'>
          <div className='row'>
            <div className={`col-12 ${this.state.page === 'home' ? 'col-md-12' : 'col-md-8'} pb-3`}>
              <div className='row'>
                {this.state.page !== 'home' && (
                  <div className='col-12 p-0'>
                    <div className='bg-secondary'>
                      <h2>Cartão Pré-Pago Like+</h2>
                    </div>
                  </div>
                )}
                <div className={`col-12 border-color-ui-3 bg-white radius`}>
                  <div className='row'>
                    <Tabs className='col-12 product-tabs border radius-top border-color-ui-3'>
                      <div className='row'>
                        <div className='draggable col-12 border-color-ui-3 bg-white border-bottom'>
                          <div className='row'>
                            <TabList disableUpDownKeys className={`draggable-item  tabs-item tab-like-plus pt-3 pb-3 col-12 px-1`}>
                              <Tab
                                onSelect={() => this.handleOnTabSelect('home')}
                                onClick={() => this.handleOnTabSelect('home')}
                                className='home-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                Início
                              </Tab>
                              {(this.state.hasCard === false) && (<Tab
                                onSelect={() => this.handleOnTabSelect('card')}
                                onClick={() => this.handleOnTabSelect('card')}
                                className='card-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                Solicite
                              </Tab>)}
                              {(this.state.hasCard !== false) && (<Tab
                                onSelect={() => this.handleOnTabSelect('recharge')}
                                onClick={() => this.handleOnTabSelect('recharge')}
                                className='recharge-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                Recarregue
                              </Tab>)}
                              <a
                                role='button'
                                href='javascript:void(0)'
                                onClick={() => this.handleOnTabSelect('first-access')}
                                className='first-access-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                Primeiro Acesso
                              </a>
                              <a
                                role='button'
                                href='javascript:void(0)'
                                onClick={() => this.handleOnTabSelect('manage-card')}
                                className='manage-card-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                Meu Cartão
                              </a>
                              <a
                                role='button'
                                href='javascript:void(0)'
                                onClick={() => this.handleOnTabSelect('duplicate')}
                                className='duplicate-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                2ª via
                              </a>
                              <Tab
                                onSelect={() => this.setState({ page: 'help' })}
                                onClick={() => this.setState({ page: 'help' })}
                                className='help-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                                FAQ
                              </Tab>
                            </TabList>
                          </div>
                        </div>
                      </div>

                      <TabPanel className='mb-5 mb-md-0'>
                        <Home hasCard={this.state.hasCard} />
                      </TabPanel>

                      {(this.state.hasCard === false) && (<TabPanel>
                        <RequestCard
                          success={this.state.success}
                          initialCredit={this.state.initialCredit}
                          totalPoints={this.state.totalPoints}
                          initialMiles={this.state.initialMiles}
                          address={this.formatAddress(this.props.participant.address)}
                          handleInitialCredit={this.handleInitialCredit}
                          handleInitialMiles={this.handleInitialMiles}
                          handleAddress={this.handleAddress}
                          handlePointsConversion={this.getPointsConverted}
                          accessToken={this.props.accessToken}
                          balance={this.props.balance}
                          transactionId={this.state.transactionId}
                          intervalObservable={this.state.intervalObservable}
                          handleIntervalObservable={this.handleIntervalObservable}
                          handleDisabledConfirmButton={this.handleDisabledConfirmButton}
                          handleLoadingConfirmButton={this.handleLoadingConfirmButton} />
                      </TabPanel>)}

                      {(this.state.hasCard !== false) && (<TabPanel>
                        <Recharge
                          success={this.state.success}
                          rechargePoints={this.state.rechargePoints}
                          rechargeCredits={this.state.rechargeCredits}
                          handleRechargePoints={this.handleRechargePoints}
                          handleRechargeCredits={this.handleRechargeCredits}
                          handlePointsConversion={this.getPointsConverted}
                          accessToken={this.props.accessToken}
                          balance={this.props.balance}
                          handleAlert={this.handleAlert}
                          transactionId={this.state.transactionId}
                          intervalObservable={this.state.intervalObservable}
                          handleIntervalObservable={this.handleIntervalObservable}
                          handleDisabledConfirmButton={this.handleDisabledConfirmButton}
                          handleLoadingConfirmButton={this.handleLoadingConfirmButton} />
                      </TabPanel>)}
                      <TabPanel>
                        {yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM_MESSAGE)
                          ? (
                            <HelpCustom />
                          ) : (
                            <Help />
                          )
                        }
                      </TabPanel>

                    </Tabs>
                  </div>

                </div>
              </div>
            </div>

            { /* SIDEBAR */ }
            {
              (this.state.page === 'help' || this.state.page === 'duplicate' || this.state.page === 'manage-card' || this.state.page === 'first-access') &&
              <div className='col-12 col-md-4'>
                <div className='row'>
                  <div className='col-12'>
                    <HelpAside />
                  </div>
                </div>
              </div>
            }
            {
              this.state.page === 'recharge' &&
              <div className='col-12 col-md-4'>
                <div className='row'>
                  <div className='col-12'>

                    <RechargeAside
                      success={this.state.success}
                      participant={this.props.participant}
                      address={this.state.address}
                      rechargePoints={this.state.rechargePoints}
                      rechargeCredits={this.state.rechargeCredits}
                      handleSuccess={this.handleSuccess}
                      accessToken={this.props.accessToken}
                      balance={this.props.balance}
                      handleCardTaxesCustom={this.getPointsConverted}
                      handleAlert={this.handleAlert}
                      handleTransactionId={this.handleTransactionId}
                      disabledConfirmButton={this.state.disabledConfirmButton}
                      handleDisabledConfirmButton={this.handleDisabledConfirmButton}
                      loadingConfirmButton={this.state.loadingConfirmButton}
                      handleLoadingConfirmButton={this.handleLoadingConfirmButton} />
                  </div>
                </div>
              </div>
            }
            {
              this.state.page === 'card' &&
              <div className='col-12 col-md-4'>
                <div className='row'>
                  <div className='col-12'>

                    <RequestAside
                      success={this.state.success}
                      initialCredit={this.state.initialCredit}
                      initialMiles={this.state.initialMiles}
                      participant={this.props.participant}
                      address={this.state.address}
                      handleSuccess={this.handleSuccess}
                      handleTotalPoints={this.handleTotalPoints}
                      handleCardTaxes={this.getCardTaxes}
                      handleCardTaxesCustom={this.getPointsConverted}
                      accessToken={this.props.accessToken}
                      balance={this.props.balance}
                      handleAlert={this.handleAlert}
                      handleTransactionId={this.handleTransactionId}
                      disabledConfirmButton={this.state.disabledConfirmButton}
                      handleDisabledConfirmButton={this.handleDisabledConfirmButton}
                      loadingConfirmButton={this.state.loadingConfirmButton}
                      handleLoadingConfirmButton={this.handleLoadingConfirmButton} />
                  </div>
                </div>
              </div>
            }
            { /* SIDEBAR */ }
          </div>
        </div>
      </Fragment>
    )
  }
}

LikePlus.propTypes = {
  profile: PropTypes.shape({
    'custom:campaign_id': PropTypes.string.isRequired,
    'custom:catalog_id': PropTypes.string.isRequired,
    'custom:client_id': PropTypes.string.isRequired }),
  participant: PropTypes.shape({
    name: PropTypes.object,
    cpf: PropTypes.object,
    address: PropTypes.object
  }).isRequired,
  accessToken: PropTypes.string,
  balance: PropTypes.object
}

const mapStateToProps = ({
  participant,
  oidc: {
    user: {
      access_token: accessToken
    },
    user
  },
  balance
}) => ({ participant, accessToken, balance, profile: user && user.profile
})

export default connect(
  mapStateToProps,
  null
)(LikePlus)



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Container.js